import React, { useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import VisitorIdentification from './walkinwebFlow/VisitorIdentification';
import UnitSelection from './walkinwebFlow/UnitSelection';
import SuccessModal from './walkinwebFlow/SuccessModal';
import apiServices from '../../../../../services/apiService';
import { toast } from 'react-toastify';

const WalkInVisitorRequest = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const siteId = searchParams.get('siteId');

    const [step, setStep] = useState(1);
    const [formData, setFormData] = useState({
        visitorName: "",
        mobileNumber: "",
        emailId: "",
        address: "",
        purposeOfVisit: "",
        additionalCount: 0,
        image: null,
        selectedUnit: null
    });

    const [loading, setLoading] = useState(false);
    const [successMessage, setSuccessMessage] = useState(null);

    const updateFormData = (data) => {
        setFormData(prev => ({ ...prev, ...data }));
    };

    const handleNext = () => {
        if (!formData.visitorName || !formData.mobileNumber || !formData.image || !formData.purposeOfVisit || !formData.address) {
            toast.error("Please fill all required fields and capture a photo.");
            return;
        }
        setStep(2);
    };

    const handleBack = () => {
        setStep(1);
    };

    const handleSubmit = async () => {
        if (!formData.selectedUnit) {
            toast.error("Please select a unit to visit.");
            return;
        }

        if (!siteId) {
            toast.error("Invalid QR Code: Missing Site ID");
            return;
        }

        // Ensure image is plain base64 without data URI prefix
        let plainBase64Image = formData.image || null;
        if (plainBase64Image && plainBase64Image.includes(',')) {
            plainBase64Image = plainBase64Image.split(',')[1];
        }

        const payload = {
            siteId: parseInt(siteId),
            visitorName: formData.visitorName,
            mobileNumber: formData.mobileNumber,
            emailId: formData.emailId || "",
            address: formData.address || "",
            purposeOfVisit: formData.purposeOfVisit,
            additionalCount: parseInt(formData.additionalCount) || 0,
            image: plainBase64Image,
            isActive: 1,
            unitIds: [formData.selectedUnit.UnitId || formData.selectedUnit.unitId || formData.selectedUnit.id]
        };

        setLoading(true);
        try {
            const response = await apiServices({
                method: 'POST',
                url: `/Visitor/postVisitor`,
                data: payload
            });

            if (response?.success || response?.isSuccess) {
                const responseData = response?.data?.data?.[0] || response?.data?.[0];
                if (responseData && responseData.accessId === 0) {
                    navigate('/check-in-pass', { state: { passDetails: responseData } });
                } else {
                    setSuccessMessage("Register successfully wait till host approved you will received pass on registered mobile number.");
                }
            } else {
                toast.error(response?.message || "Failed to submit request.");
            }
        } catch (error) {
            console.error("Submission Error:", error);
            toast.error("An error occurred during submission.");
        } finally {
            setLoading(false);
        }
    };

    const handleCloseSuccess = () => {
        setSuccessMessage(null);
        setStep(1);
        setFormData({
            visitorName: "",
            mobileNumber: "",
            emailId: "",
            address: "",
            purposeOfVisit: "",
            additionalCount: 0,
            image: null,
            selectedUnit: null
        });
    };

    if (successMessage) {
        return (
            <div className="h-screen w-full overflow-hidden flex flex-col bg-white sm:max-w-md sm:mx-auto sm:shadow-2xl relative">
                <SuccessModal message={successMessage} onClose={handleCloseSuccess} />
            </div>
        );
    }

    return (
        <div className="h-screen w-full overflow-hidden flex flex-col bg-white sm:max-w-md sm:mx-auto sm:shadow-2xl relative">
            {loading && (
                <div className="absolute inset-0 bg-white/70 z-50 flex items-center justify-center">
                    <div className="w-8 h-8 border-4 border-gray-400 border-t-transparent rounded-full animate-spin"></div>
                </div>
            )}

            {step === 1 && (
                <VisitorIdentification
                    formData={formData}
                    onUpdate={updateFormData}
                    onNext={handleNext}
                />
            )}
            {step === 2 && (
                <UnitSelection
                    formData={formData}
                    onUpdate={updateFormData}
                    onBack={handleBack}
                    onNext={handleSubmit}
                />
            )}
        </div>
    );
};

export default WalkInVisitorRequest;
